import palette from '@assets/theme/palette';
import EditIcon from '@components/icons/Edit';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { formatPrice } from '@pages/OfferDetail/helpers';
import { LocalizedMessage } from '@services/requests/localizedMessagesService/interfaces';
import { UnitData } from '@services/requests/searchLoaders/unitLoader/UnitLoaderQuery';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { LoadedPallet } from '../../../../types';

interface PalletParametersItemProps {
  palletIndex: number;
  palletData: LoadedPallet;
  isActionsDisabled: boolean;
  availablePalletUnits: UnitData[];
  onGenerateLocalizedName: (defaultName: string, localizations: LocalizedMessage[]) => string;
  onDeletePallet: () => void;
  onEditPallet: () => void;
}

function PalletParametersItem({
  palletIndex,
  palletData,
  availablePalletUnits,
  isActionsDisabled,
  onDeletePallet,
  onGenerateLocalizedName,
  onEditPallet,
}: PalletParametersItemProps) {
  const { t } = useTranslation('Common');

  const foundUnit = availablePalletUnits.find((p) => p.id === palletData.type);
  const palletDescripion = `${onGenerateLocalizedName(
    foundUnit.unit_symbol,
    foundUnit.localized_unit_symbols_data
  )} (${formatPrice(palletData.weight, 0)} ${t('Common:kg')}) × ${palletData.quantity}`;

  return (
    <div className="pallet-item">
      <div className="pallet-item__wrap">
        <div className="pallet-item__name">
          <span>
            #{palletIndex + 1}
            {': '}
            {palletDescripion}
          </span>
        </div>
        <div className="pallet-item__control">
          <Tooltip title={t('Common:EditPallet')}>
            <IconButton
              color="primary"
              size="small"
              disabled={isActionsDisabled}
              onClick={onEditPallet}
            >
              <EditIcon sx={{ fontSize: '20px' }} style={{ color: palette.light.grey[700] }} />
            </IconButton>
          </Tooltip>
          <Tooltip title={t('Common:DeletePallet')}>
            <IconButton
              color="primary"
              size="small"
              disabled={isActionsDisabled}
              onClick={onDeletePallet}
            >
              <CloseIcon sx={{ fontSize: '20px' }} style={{ color: palette.light.grey[700] }} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export { PalletParametersItem };
